/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, getter-return, warp-drive/no-legacy-request-patterns */
// Extends from
import Controller, { inject as controller } from '@ember/controller';
// Ember Imports
import { get, action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// External Imports
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class PersonController extends Controller {
  @controller('people.person.page')
  pageController;

  @service
  dates;

  @service
  features;

  @service
  print;

  @service
  roles;

  @service
  router;

  @service
  store;

  @service
  strings;

  @alias('features.sidekickEnabled')
  sidekickEnabled;

  PersonType = PersonType;

  @computed(
    'features.heroSuiteEnabled',
    'dates.isOpen',
    'model.person.type',
    'router.currentRouteName',
  )
  get showQuickAttendance() {
    // If Hero SMS isn't enabled, there's no attendance to show.
    if (!this.features.heroSuiteEnabled) {
      return false;
    }
    // Don't show on the Attendance route; we show all periods there.
    if (this.router.currentRouteName === 'people.person.attendance') {
      return false;
    }
    // If it's not a learner, or school is closed, don't show anything.
    return this.model.person.type === PersonType.LEARNER && this.dates.isOpen;
  }

  @computed(
    'model.person.type',
    'model.person.learner.medicalConditions.@each.{isSerious,isCurrent}',
  )
  get seriousMedicalConditions() {
    if (this.model.person.type !== PersonType.LEARNER) {
      return;
    }
    return this.get('model.person.learner.medicalConditions').filter(
      (condition) => {
        return condition.get('isSerious') && condition.get('isCurrent');
      },
    );
  }

  @computed(
    'sidekickEnabled',
    'model.person.type',
    'router.{currentRoute,currentRouteName}',
  )
  get sidekickData() {
    if (!this.sidekickEnabled) {
      // Don't try generating any Sidekick codes if it's not enabled.
      return;
    }
    if (this.model.person.type === PersonType.LEARNER) {
      let route = this.router.currentRouteName;
      if (route.startsWith('people.person.page')) {
        // When viewing a Page, include it in the Sidekick code.
        let pageRoute = this.router.currentRoute.find(
          (r) => r.name === 'people.person.page',
        );
        let page;
        if (!isEmpty(pageRoute) && !isEmpty(get(pageRoute, 'params.page_id'))) {
          page = this.store.peekRecord('posts/page', pageRoute.params.page_id);
        }
        if (page && !page.hasPosts) {
          // Don't try generating any Sidekick codes if the page does not
          // have posts enabled.
          return;
        }
        return {
          person: this.model.person,
          page,
        };
      }
      if (route === 'people.person.index') {
        // When viewing the learner homepage, only include the person.
        return { person: this.model.person };
      }
    }
  }

  // sickbayEntryCreatedAction refreshes the posts when the sickbay page is
  // showing, so the new entry's post appears.
  @action
  sickbayEntryCreatedAction() {
    if (this.router.currentRouteName !== 'people.person.page.index') {
      return;
    }
    let pageModel = this.pageController.model;
    if (!isEmpty(pageModel?.page) && pageModel.page.isSickbay) {
      pageModel.posts.update();
    }
  }
}
